import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import client from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LangContext";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PayPalReturn() {
  const [params] = useSearchParams();
  const orderId = params.get("token");
  const { refresh } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const [status, setStatus] = useState("capturing");

  useEffect(() => {
    if (!orderId) { setStatus("error"); return; }
    let cancelled = false;
    (async () => {
      try {
        const { data } = await client.post(`/payments/paypal/capture/${orderId}`);
        if (cancelled) return;
        if (data.payment_status === "paid") {
          setStatus("paid");
          await refresh();
        } else {
          setStatus("failed");
        }
      } catch (e) {
        if (!cancelled) setStatus("failed");
      }
    })();
    return () => { cancelled = true; };
  }, [orderId]);

  return (
    <div className="min-h-[calc(100vh-64px)] flex items-center justify-center px-6 py-16">
      <div className="surface p-12 max-w-md w-full text-center" data-testid="paypal-status-card">
        {status === "capturing" && (<>
          <Loader2 size={48} className="text-[#CCFF00] animate-spin mx-auto" />
          <h2 className="font-display text-2xl mt-6">{t("payment_processing")}</h2>
          <div className="mt-2 text-xs font-mono text-white/40">PayPal</div>
        </>)}
        {status === "paid" && (<>
          <CheckCircle2 size={48} className="text-[#CCFF00] mx-auto" />
          <h2 className="font-display text-2xl mt-6">{t("payment_success")}</h2>
          <button data-testid="paypal-success-dashboard-button" onClick={() => nav("/dashboard")} className="btn-acid mt-8">Go to Dashboard</button>
        </>)}
        {(status === "failed" || status === "error") && (<>
          <XCircle size={48} className="text-[#FF3366] mx-auto" />
          <h2 className="font-display text-2xl mt-6">{t("payment_failed")}</h2>
          <button onClick={() => nav("/programs")} className="btn-ghost mt-8">Back to Programs</button>
        </>)}
      </div>
    </div>
  );
}
